import { createAction } from '@reduxjs/toolkit'
import { call, delay, put, takeEvery } from 'redux-saga/effects'

import IndexableObject from '../../../shared/constants/general-enums/indexableObject'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Select, Workspace } from '../../lib/toolBoxes/2D'
import { updateToolbarMessage } from '../../slices/common'
import { SAGA_THROTTLE_TIMER, SELECTING_MATERIAL } from '../../types'

export const selectPastedMaterialAction = createAction<number[]>('selectPastedMaterial')

export function determineWhichDrawableOrLocationToSelect(idsToSelect: number[]) {
    return (data: IndexableObject) => {
        return (
            (idsToSelect.includes(data.drawable_id) || idsToSelect.includes(data.opening_location_id)) &&
            data.isMultiSelectable
        )
    }
}

export function* handleSelectPastedMaterial(action: ReturnType<typeof selectPastedMaterialAction>) {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (!manager) return

    yield put(updateToolbarMessage(SELECTING_MATERIAL))

    const [selectTool, workspaceTool]: [Select, Workspace] = yield call(manager.getTools, [Select.NAME, Workspace.NAME])

    let items: paper.Item[] = yield call(
        workspaceTool.getItemsWithCriteria,
        'data',
        determineWhichDrawableOrLocationToSelect(action.payload)
    )

    let visibleItems = items.filter((item) => item.visible === true)

    while (visibleItems.length < action.payload.length) {
        // Need to slow down the looping to ensure that
        // digitizer does not crash
        yield delay(SAGA_THROTTLE_TIMER)

        items = workspaceTool.getItemsWithCriteria('data', determineWhichDrawableOrLocationToSelect(action.payload))
        visibleItems = items.filter((item) => item.visible === true)
    }

    yield put(updateToolbarMessage(null))

    yield call([selectTool, 'createMultiSelectionGroupFromItems'], visibleItems)
}

export function* watchForSelectPastedMaterial() {
    yield takeEvery(selectPastedMaterialAction.type, handleSelectPastedMaterial)
}
